// Role hierarchy, highest first. Roles on the same tier rank equally (technician = sales).
// Roles the API returns that aren't listed here sort after these, alphabetically.
export const ROLE_TIERS: string[][] = [
  ['developer'],
  ['admin'],
  ['corporate'],
  ['owner'],
  ['dealer'],
  ['technician', 'sales'],
  ['marketing'],
  ['customer'],
];

const tierOf = new Map<string, number>();
ROLE_TIERS.forEach((tier, index) => tier.forEach((name) => tierOf.set(name, index)));

// 0 for the top tier; roles outside the hierarchy get a rank past the last tier
export const roleRank = (name?: string | null): number =>
  tierOf.get((name ?? '').toLowerCase()) ?? ROLE_TIERS.length;

// Hierarchy order; ties and unknown roles fall back to the name
export const compareRoles = (a?: string | null, b?: string | null): number => {
  const byRank = roleRank(a) - roleRank(b);
  if (byRank !== 0) return byRank;
  const tier = ROLE_TIERS[roleRank(a)];
  if (tier) {
    const byTier = tier.indexOf((a ?? '').toLowerCase()) - tier.indexOf((b ?? '').toLowerCase());
    if (byTier !== 0) return byTier;
  }
  return (a ?? '').localeCompare(b ?? '');
};

// "technician" -> "Technician"
export const roleLabel = (name?: string | null): string =>
  (name ?? '').replace(/[_-]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
